document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('[data-btn-addtocart]').forEach(function(button) {
    button.addEventListener('click', function() {

      document.body.classList.remove('quickshop-popup-show');

      const card = document.querySelector('.product-item.quickshop-popup-show');
      if(card) card.classList.remove('quickshop-popup-show');
    });
  });
});
